export default __webpack_public_path__ + "static/Metropolis-MediumItalic-831d61b8540ded10b598bd1d00253fae.woff2";